<template>
  <div class="login-body">
    <div class="logo-login">
      <img src="/images/connect_logo.png" />
      <span class="logo-name">{{ $t("dashboard") }}</span>
    </div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="field">
        <div class="p-float-label p-input-icon-right">
          <i class="pi pi-user" />
          <Password
            id="password"
            :placeholder="$t('firstAccess_label_oldPassword')"
            v-model = "v$.oldPassword.$model"
            :class="{'p-invalid':v$.oldPassword.$invalid && submitted}"
            :feedback="false"
            toggleMask
          />
        </div>
          <small v-if="(v$.oldPassword.$invalid && submitted) || v$.oldPassword.$pending.$response" class="p-error">Old password empty</small>
        <!-- <small
          v-if="
            (v$.password.$error && submitted) || v$.password.$pending.$response
          "
          class="p-error"
          >Password empty</small
        > -->
      </div>
      <div class="field">
        <div class="p-float-label p-input-icon-right">
          <i class="pi pi-user" />
          <Password
            id="password"
            :placeholder="$t('firstAccess_label_newPassword')"
            v-model ="v$.changePassword.$model"
            :class="{'p-invalid':v$.changePassword.$invalid && submitted}"
            :feedback="false"
            toggleMask
          />
        </div>
          <small v-if="(v$.changePassword.$invalid && submitted)" class="p-error">{{ $t('firstAccess_label_newPasswordEmpty') }}</small>
        <!-- <small
          v-if="
            (v$.password.$error && submitted) || v$.password.$pending.$response
          "
          class="p-error"
          >Password empty</small
        > -->
      </div>

      <div class="field">
        <div class="p-float-label p-input-icon-right">
          <i class="pi pi-user" />
          <Password
            id="password"
            :placeholder="$t('firstAccess_label_confirmPassword')"
            v-model ="v$.newPassword.$model"
            :class="{'p-invalid':(v$.newPassword.$invalid && submitted)}"
            :feedback="false"
            toggleMask
          />
        </div>
        <small v-if="(v$.newPassword.$invalid && submitted) || (!v$.newPassword.sameAsPassword && submitted)  || v$.changePassword.$pending.$response" class="p-error">{{$t('firstAccess_label_newPasswordEmpty')}}</small>
        <!-- <small
          v-if="
            (v$.password.$error && submitted) || v$.password.$pending.$response
          "
          class="p-error"
          >Password empty</small
        > -->
      </div>

      <!-- <div class="field-checkbox">
        <Checkbox
          id="accept"
          name="accept"
          value="Accept"
        />
        <label for="accept">Remember me</label>
      </div> -->
      <Button type="submit" :label="$t('firstAccess_button_changePassword')" class="mt-2" />
      <small v-if="error" class="p-error">{{ this.error }}</small>
    </form>
  </div>
</template>



<script>
import { useVuelidate } from "@vuelidate/core";
import { required, sameAs } from "@vuelidate/validators";
import LoginService from "../service/LoginService";
import { useLoginStore } from "../stores/login.js";
import { mapActions, mapState } from "pinia";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      submitted: false,
      newPassword: null,
      accept: false,
      error: null,
      oldPassword: null,
      changePassword: null
    };
  },
  created() {
    this.loginService = new LoginService();
    this.oldPassword = this.getPassword;
  },
  validations() {
    return {
      oldPassword: {
        required,
      },
      changePassword: {
        required,
      },
      newPassword: {
        required,
        sameAsPassword: sameAs(this.changePassword)
      },
      accept: {
        required,
      },
    };
  },

  computed: {
    ...mapState(useLoginStore, ["getUsername", "getPassword", "getSession"]),
  },
  
  methods: {
    ...mapActions(useLoginStore, ["setTenant", "setLoginParameters", "setAbacConfig", "addRoutesMenu"]),
    ...mapState(useLoginStore, ["getAbacConfig", "getTenant"]),
    handleSubmit(isFormValid) {
      this.submitted = true;
      
      if (!isFormValid) {
        return;
      }

      this.login();
    },
    login: async function () {
      this.error = null;
      this.loading = true;
      this.loginService
        .firstAccess(this.getUsername, this.newPassword, this.getSession)
        .then(async (data) => {
          if (data.status && data.status === 200) {
            this.setLoginParameters(
              // data.data.AuthenticationResult.AccessToken,
              // data.data.AuthenticationResult.ExpiresIn,
              // data.data.AuthenticationResult.RefreshToken,
              // data.data.AuthenticationResult.IdToken
              data.data.accessToken,
              86400,
              data.data.refreshToken,
              data.data.accessToken,
              data.data.iotUserCode
            );
            this.loading = false;
            await this.setAbacConfig();
            let tenant_obj = {label: (this.getAbacConfig()).tenants[0], key: (this.getAbacConfig()).tenants[0]};
            await this.setTenant(tenant_obj);
            this.addRoutesMenu(this.$router);
            this.$router.push({
              name: "Appliances",
            });
          } else {
            this.loading = false;
            this.error = data.response.data.message;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.error = error;
        });
    },
  },
};
</script>
